import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { settingsI18n } from '#src/i18nMessages/index.ts';
import { SettingsMenuPage } from '#src/pages/Settings/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/settings_/')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <title>{intl.formatMessage(settingsI18n.accountSettingsHeading)}</title>
      </Head>
      <SettingsMenuPage />
    </>
  );
}
